import { Option } from 'effect';

import type { ProductSummary } from '@vs-shop/engine/capability/productSchema';

import { toProductCard } from './toProductCard';

/** Maps shared listing facts into RCProfi's existing card data. */
export const toListingCard = (summary: ProductSummary) => {
  const facts = summary.listingFacts;
  if (facts === undefined) throw new Error('RCProfi listing card facts missing');

  return toProductCard(
    {
      code: summary.code,
      routerUrl: Option.getOrElse(summary.href, () => ''),
      name: Option.getOrNull(summary.name),
      metaTitle: facts.metaTitle,
      slug: facts.slug,
      shortDescription: facts.description,
      subtitle: Option.getOrNull(summary.subtitle),
      mainImage: facts.imagePath === null ? null : { pathAbstract: facts.imagePath },
      ageRestriction: facts.ageRestriction,
    },
    {
      price: Option.getOrUndefined(summary.price),
      priceWithoutTax: Option.getOrUndefined(summary.priceWithoutTax),
      originalPrice: Option.getOrNull(summary.originalPrice),
      isFavourite: Option.getOrUndefined(summary.isFavourite),
      available: facts.available ?? undefined,
      stockStatus: facts.stockStatus ?? undefined,
      maxOrderable: Option.getOrUndefined(summary.maxOrderable),
      dispatchDate: facts.dispatchDate,
      localWarehouse: facts.localWarehouse,
      couponCodes: facts.coupons,
      labels: facts.labels,
    }
  );
};
